import { render } from "./ResidentsList.vue?vue&type=template&id=6a56697d&scoped=true"
import script from "./ResidentsList.vue?vue&type=script&lang=js"
export * from "./ResidentsList.vue?vue&type=script&lang=js"

import "./ResidentsList.vue?vue&type=style&index=0&id=6a56697d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a56697d"]])

export default __exports__